<template>
  <div class="report-career" dir="rtl">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

    <header>
      <div class="md-layout md-size-100">
        <div class="md-layout-item md-size-100 mt-25">
          <h3 class="text-center">{{ allData.fullName }}</h3>
          <h3 class="text-center">{{ allData.shortName }}</h3>
          <h3 class="text-center">
            بطاقة المرتب للموظفين الشهريين مصنفين وغير مصنفين
          </h3>
          <h3
            class="text-center"
            style="margin-left: 50px; margin-bottom: 50px"
          >
            بتاريخ : {{ convert(new Date()) }}
          </h3>
        </div>

        <div class="md-layout">
          <div class="md-layout-item">
            <md-card>
              <md-card-header
                style="margin-bottom: 30px"
                class="md-card-header-text md-card-header-green"
              >
                <div class="card-text">
                  <h4 class="title">بطاقة المرتب للموظفين</h4>
                </div>
              </md-card-header>
              <form>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-30 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>الإسم</label>
                        <md-input
                          disabled
                          v-model="allData.employeeName"
                        ></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>المصرف</label>
                        <md-input
                          disabled
                          v-model="allData.bankBranchName"
                        ></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>الدرجة</label>
                        <md-input disabled v-model="allData.degree"></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>العلاوة</label>
                        <md-input disabled v-model="allData.bonuse"></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>مقر الوظيفة </label>
                        <md-input
                          disabled
                          v-model="allData.workPlace"
                        ></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>الوظيفة</label>
                        <md-input disabled v-model="allData.job"></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>رقم الحساب</label>
                        <md-input
                          disabled
                          v-model="allData.accountNumber"
                        ></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>رقم الحساب الآلي</label>
                        <md-input
                          disabled
                          v-model="allData.financialNumber"
                        ></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 mt-25 ml-15">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <label>شهر الزيادة</label>
                        <md-input v-model="date"></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-card-content>
              </form>

              <div
                style="margin-top: 10px; margin-bottom: 35px"
                class="marginTop"
              >
                <md-card-content>
                  <md-table
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row>
                      <md-table-cell class="w-70">الشهر</md-table-cell>

                      <md-table-cell class="w-70">الأساسي</md-table-cell>

                      <md-table-cell class="w-70">ع.اللجان</md-table-cell>

                      <md-table-cell class="w-70">ع.المكافآت</md-table-cell>

                      <md-table-cell class="w-70"
                        >ع.العمل الإضافي</md-table-cell
                      >

                      <md-table-cell
                        class="w-70"
                        v-for="(item2, j) in allowances"
                        :key="j"
                        md-label="الصنف"
                        >{{ item2.key }}</md-table-cell
                      >

                      <md-table-cell class="w-70">الإجمالي</md-table-cell>

                      <md-table-cell v-if="!privateCompanyMode" class="w-70"
                        >الضمان</md-table-cell
                      >

                      <md-table-cell v-if="!privateCompanyMode" class="w-70"
                        >التضامن</md-table-cell
                      >

                      <md-table-cell v-if="!privateCompanyMode" class="w-70"
                        >الدخل</md-table-cell
                      >

                      <md-table-cell v-if="!privateCompanyMode" class="w-70"
                        >الجهاد</md-table-cell
                      >

                      <md-table-cell v-if="!privateCompanyMode" class="w-70"
                        >الدمغة</md-table-cell
                      >

                      <md-table-cell v-if="!privateCompanyMode" class="w-70"
                        >الدينار</md-table-cell
                      >

                      <md-table-cell class="w-70">خ.غياب</md-table-cell>

                      <md-table-cell class="w-70">الخصميات</md-table-cell>

                      <md-table-cell class="w-70">صافي المرتب</md-table-cell>

                      <md-table-cell class="w-70">فروفات</md-table-cell>

                      <md-table-cell class="w-70">خصميات اخرى</md-table-cell>
                    </md-table-row>
                    <md-table-row v-for="(item, i) in tableData" :key="i">
                      <md-table-cell md-label="الصنف">{{
                        convertMonth(item.date)
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.basicSalary.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.committeesAllownace.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.rewards.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.overTime.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell
                        v-for="(item2, j) in allowances"
                        :key="j"
                        md-label="الصنف"
                        >{{ item2.value }}</md-table-cell
                      >

                      <md-table-cell md-label="الصنف">{{
                        item.totalSalary.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell
                        v-if="!privateCompanyMode"
                        md-label="الصنف"
                        >{{ item.warrantyTax.toLocaleString() }}</md-table-cell
                      >

                      <md-table-cell
                        v-if="!privateCompanyMode"
                        md-label="الصنف"
                        >{{
                          item.solidarityTax.toLocaleString()
                        }}</md-table-cell
                      >

                      <md-table-cell
                        v-if="!privateCompanyMode"
                        md-label="الصنف"
                        >{{ income }}</md-table-cell
                      >

                      <md-table-cell
                        v-if="!privateCompanyMode"
                        md-label="الصنف"
                        >{{ item.jihadTax.toLocaleString() }}</md-table-cell
                      >

                      <md-table-cell
                        v-if="!privateCompanyMode"
                        md-label="الصنف"
                        >{{ item.stampTax.toLocaleString() }}</md-table-cell
                      >

                      <md-table-cell
                        v-if="!privateCompanyMode"
                        md-label="الصنف"
                        >{{ dinar.toLocaleString() }}</md-table-cell
                      >

                      <md-table-cell md-label="الصنف">{{
                        item.absanceDiscount.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.totalDiscount.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.netSalary.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.differences.toLocaleString()
                      }}</md-table-cell>

                      <md-table-cell md-label="الصنف">{{
                        item.otherDiscounts.toLocaleString()
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </div>
            </md-card>
          </div>
        </div>
      </div>
    </header>

    <div class="md-layout mt-25 text-center last-footer">
      <div class="md-layout-item md-size-30">
        <p style="font-weight: bold">توقيع وإعتماد رئيس القسم المالي</p>
      </div>

      <div class="md-layout-item md-size-30">
        <p style="font-weight: bold">
          توقيع وإعتماد مدير الشؤون الإدارية والمالية
        </p>
      </div>

      <div class="md-layout-item md-size-30">
        <p style="font-weight: bold">توقيع وإعتماد المراجعة الداخلية</p>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  created() {
    this.date = this.convert(this.allData.bonusDueDate);
    const styleValue = localStorage.getItem("privateCompanyMode");
    this.privateCompanyMode = styleValue === "true";
  },

  props: ["allData", "tableData", "allowances"],

  data() {
    return {
      privateCompanyMode: false,
      income: 0,
      dinar: 1,
      date: null,
      m: env.mTop(),
    };
  },

  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertMonth(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1)

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss">
.w-70 .md-table-cell-container {
  width: 70px !important;
}
</style>
